<template>
  <div class="pt20">
    <div class="row form-step__heading">
      <div
        class="number-circle lh35 cl-white brdr-circle align-center weight-700"
        :class="{ 'bg-cl-th-accent' : isActive || isFilled, 'bg-cl-tertiary' : !isFilled && !isActive }"
      >
        1
      </div>
      <div class="col-xs-10 col-sm-9 col-md-10 checkout-step-info-container">
        <div class="row mb15">
          <div class="col-xs-12 col-md-7" :class="{ 'cl-bg-tertiary' : !isFilled && !isActive }">
            <h3 class="m0 lh35 cl-accent">
              {{ $t('Additional services') }}
            </h3>
          </div>
          <div class="col-xs-12 col-md-5" v-if="!isActive && isFilled">
            <div class="lh35 flex end-lg edit-section-container">
              <a href="#" class="cl-tertiary flex edit-section-button" @click.prevent="edit('returnShipping')">
                <span class="pr5">
                  {{ $t('Edit Additional services') }}
                </span>
                <i class="material-icons cl-tertiary">edit</i>
              </a>
            </div>
          </div>
        </div>

        <div v-if="!isActive && isFilled" class="row unactive">
          <div class="relative">
            <loader-overlay class="row" />
            <div v-if="products && getPossibleAdditionalServices().length > 0">
              <div
                v-for="(product, productIndex) in products"
                :key="`product${productIndex}`"
              >
                <div
                  v-for="(item, itemIndex) in product.items"
                  :key="`item${itemIndex}`"
                  class="row middle-xs"
                >
                  <HeaderDropDown
                    v-if="shouldDisplayHeaderDropDown(item)"
                    :arrow-hidden="!isActive"
                    :disabled="!isActive"
                    :is-open="openedProductsDropdown.hasItem(`${product.id}_${item.id}`) "
                    :text="product.name"
                    :on-click="()=>openedProductsDropdown.toggle(`${product.id}_${item.id}`)"
                  />
                  <!-- services -->
                  <div class="col col-services">
                    <div class="row mb15 relative service-row" v-for="(service) in item.services" :key="`service_key${service.serviceKey}`"
                         v-if="openedProductsDropdown.hasItem(`${product.id}_${item.id}`) || service.selected"
                    >
                      <CheckboxWithLabel
                        :id="'checkbox' + service.serviceKey"
                        :disabled="!openedProductsDropdown.hasItem(`${product.id}_${item.id}`)"
                        :checked="service.selected"
                        @input="() => handleServiceSelect(service)"
                        input-class="m0 no-outline checkbox checkbox-input"
                        label-class="pl35 lh30 h4 pointer ml10"
                      >
                        {{ service.name }} {{ renderServiceOptionInOverview(product, service) }} | {{ service.price }}
                        {{ priceDetails }}
                      </CheckboxWithLabel>
                      <div class="relative ml15  row service-row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-4 pr20">
                          <div class="select-wrapper md-mmr40">
                            <Aselect v-if=" (service.options &&
                                       service.options.length && (openedProductsDropdown.hasItem(`${product.id}_${item.id}`))) "
                                     :value="service.selected_option"
                                     :options="service.options"
                                     :on-option-select="(option)=>{handleOptionSelect(service,option)}"
                                     :disabled="!service.selected"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="products && !getPossibleAdditionalServices().length">
                <span class="pr5">
                  {{ $t('No additional services available') }}
                </span>
              </div>
            </div>
          </div>
          <div class="row">
            <div>
              <div class="row">
                <h4 class="align-left cl-accent" v-if="isActive || !isActive && !!userNote">
                  {{ $t('Order note') }}
                </h4>
              </div>
              <div class="row">
                <span v-if="!isActive && !!userNote">{{ userNote }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-12" v-if="isActive">
        <p>{{ $t(products && getPossibleAdditionalServices().length > 0 ? 'Select additional services and enter the necessary data:' : 'No additional services available') }}</p>
        <div class="row">
          <div class="relative">
            <loader-overlay class="row" />
            <div v-if="products && getPossibleAdditionalServices().length > 0">
              <div
                v-for="(product, productIndex) in products"
                :key="`product${productIndex}`"
              >
                <div
                  v-for="(item, itemIndex) in product.items"
                  :key="`item${itemIndex}`"
                  class="row middle-xs"
                >
                  <HeaderDropDown
                    v-if="shouldDisplayHeaderDropDown(item)"
                    :arrow-hidden="!isActive"
                    :disabled="!isActive"
                    :is-open="openedProductsDropdown.hasItem(`${product.id}_${item.id}`) "
                    :text="product.name"
                    :on-click="()=>openedProductsDropdown.toggle(`${product.id}_${item.id}`)"
                  />
                  <!-- services -->
                  <div class="col col-services">
                    <div class="row mb15 relative service-row" v-for="(service) in item.services" :key="`service_key${service.serviceKey}`"
                         v-if="openedProductsDropdown.hasItem(`${product.id}_${item.id}`) || service.selected"
                    >
                      <CheckboxWithLabel
                        :id="'checkbox' + service.serviceKey"
                        :disabled="!openedProductsDropdown.hasItem(`${product.id}_${item.id}`)"
                        :checked="service.selected"
                        @input="() => handleServiceSelect(service)"
                        input-class="m0 no-outline checkbox checkbox-input"
                        label-class="pl35 lh30 h4 pointer ml10"
                      >
                        {{ service.name }} {{ renderServiceOptionInOverview(product, service) }} | {{ service.price }}
                        {{ priceDetails }}
                      </CheckboxWithLabel>
                      <div class="relative ml15  row service-row">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-4 pr20">
                          <div class="select-wrapper md-mmr40">
                            <Aselect v-if=" (service.options &&
                                       service.options.length && (openedProductsDropdown.hasItem(`${product.id}_${item.id}`))) "
                                     :value="service.selected_option"
                                     :options="service.options"
                                     :on-option-select="(option)=>{handleOptionSelect(service,option)}"
                                     :disabled="!service.selected"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isActive">
      <div class="row">
        <h4 class="align-left cl-accent" v-if="isActive">
          {{ $t('Order note') }}
        </h4>
      </div>
      <div class="row">
        <base-input
          v-if="isActive"
          id="order-note"
          :placeholder="$t('Your note')"
          :maxlength="200"
          class="w-100"
          :class="{'color-gray':!isActive}"
          v-model="userNote"
          type="text"
        />
      </div>
    </div>
    <div class="row mb30 btn-row">
      <template v-if="isActive">
        <div>
          <div class="row">
            <div>
              <button-full
                data-testid="servicesSubmit"
                @click.native="sendDataToCheckout()"
                :disabled="false"
                wrap-style="button-full-wrap-partner"
              >
                {{ $t('Continue to personal details') }}
              </button-full>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { currentStoreView } from '@vue-storefront/core/lib/multistore';

import ButtonFull from 'theme/components/theme/ButtonFull';
import Aselect from '../../../theme/anyrent/aselect/Aselect';
import ToggleArray from '../../../theme/anyrent/helpers/ToggleArray';
import BaseInput from 'theme/components/core/blocks/Form/BaseInput';
import debounce from 'lodash-es/debounce'
import LoaderOverlay from '../../LoaderOverlay.vue'
import HeaderDropDown from '../../../theme/HeaderDropDown';
import CheckboxWithLabel from 'theme/components/theme/CheckboxWithLabel.vue';

export default {
  name: 'AdditionalServices',
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    checkoutConfig: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    BaseInput,
    ButtonFull,
    Aselect,
    LoaderOverlay,
    HeaderDropDown,
    CheckboxWithLabel
  },
  data () {
    return {
      isFilled: false,
      activeServices: [],
      openedProductsDropdown: new ToggleArray(),
      activeServicesIdList: [],
      priceDetails: 'Kč vč. DPH'
    };
  },
  computed: {
    storeView () {
      return currentStoreView();
    },
    products () {
      return this.$store.getters['additionalServices/getProducts'];
    },
    userNote: {
      get () {
        return this.$store.getters['checkout/getUserNote'];
      },
      set (note) {
        this.$store.dispatch('checkout/setUserNote', note);
      }
    }

  },
  beforeMount () {
    const hasProducts = this.products && this.products.length
    const hasItems = hasProducts && this.products[0].items && this.products[0].items.length
    if (hasItems) {
      const product = this.products[0]
      const item = this.products[0].items[0]
      const arr = [`${product.id}_${item.id}`]
      this.openedProductsDropdown.setArray(arr)
    }
  },
  methods: {
    updateService: debounce(function () {
      const servicesToUpdate = this.products.flatMap(product => {
        return product.items.map(item => {
          return item.services.filter(service => service.selected)
        })
      }).flat()
      if (servicesToUpdate) {
        this.$store.dispatch('additionalServices/setActive', servicesToUpdate)
      }
    }, 1500),
    shouldDisplayHeaderDropDown (item) {
      return this.isActive || (this.getSelectedServiceOptions(item).length && !this.isActive);
    },
    renderServiceOptionInOverview (product, service) {
      if ((!this.openedProductsDropdown.hasItem(`${product.id}_${service.item_id}`) || !this.isActive) && service.selected_option) {
        return ' - ' + service.selected_option.name;
      }
      return '';
    },
    getSelectedServiceOptions (item) {
      return item.services.filter(service => service.selected);
    },
    handleServiceSelect (service) {
      service.selected = !service.selected;
      this.updateService()
    },
    handleOptionSelect (service, option) {
      if (!service.selected) {
        service.selected = true;
      }
      service.selected_option = option;
      this.updateService()
    },
    getPossibleAdditionalServices () {
      const possibleServices = [];
      for (const product of this.products) {
        for (const item of product.items) {
          if (item?.services) {
            for (const service of item.services) {
              possibleServices.push(service);
            }
          }
        }
      }
      return possibleServices;
    },
    sendDataToCheckout () {
      this.openedProductsDropdown.setArray([])
      this.isFilled = true;
      this.$bus.$emit('checkout-after-additionalServices');
    },
    edit () {
      this.$bus.$emit('checkout-before-edit', 'additionalServices');
    }
  }
};
</script>
<style lang='scss' scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/base/global_vars';
@import '~theme/css/helpers/functions/color';
@import '~theme/css/components/_checkboxes';
@import '~theme/css/layout/_margin';

$color-silver: color(silver);
$color-active: color(partner);
$color-white: color(white);
$color-gray: color(gray);
$color-partner: color(partner);
$color-matterhorn: color(matterhorn);

.color-gray {
  color: $color-gray;
}

.select-wrapper {
  width: 200px;
}

.select-wrapper::v-deep .vs__search {
  visibility: collapse;
  display: none;
}

.text-align-left {
  text-align: left;
}

.float-left {
  float: left;
}

.pr20{
  padding-right: 20px;
}

.float-right {
  float: right;
}

.order-note {
  color: $color-matterhorn;
  font-size: 18px;
  font-weight: bold;
  min-width: 50px;
}

.service-row {
  gap: 1rem;
  align-items: center;
  height: fit-content;
  min-height: 40px;
}
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
@import '~theme/css/components/_checkboxes';
@import '~theme/css/layout/_margin';

$color-silver: color(silver);
$color-active: color(anyrent);
$color-white: color(white);
$color-partner: color(anyrent);
$color-matterhorn: color(matterhorn);

.text-input {
  padding-left: 10px;
  border: 1px solid $color-silver;
  outline: 0;
  height: 30px;
  color: $color-matterhorn;
}
.text-input:focus {
  outline: 0;
  border: 1px solid $color-partner;
}
.text-input:active {
  border: 1px solid $color-silver;
}
.text-input::placeholder{
  color:  $color-silver;
}
.col-services {
  flex: 1;
  padding-left: 1rem;
}
.font-size-22 {
  font-size: 22px;
}
::v-deep input[type=text] {
  border: 1px solid $color-silver;
}
@media only screen and (max-width: 576px) {
  .select-wrapper {
    width: auto;
    float: none;
  }
}
@media only screen and (max-width: 992px) {
  .md-mmr40{
    margin-left: 42px;
  }
}

</style>
